const submitType = {
  CONSULT: 'CONSULT',
  EXPORT_CSV: 'EXPORT_CSV',
  EXPORT_FACE_SHEET_LABEL_A4: 'EXPORT_FACE_SHEET_LABEL_A4',
  EXPORT_FACE_SHEET_LABEL_A5: 'EXPORT_FACE_SHEET_LABEL_A5',
};

export default submitType;
